var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-drawer",
    {
      staticClass: "auto_group_dialog",
      attrs: {
        modal: true,
        "modal-append-to-body": true,
        visible: _vm.show,
        "close-on-click-modal": false,
        direction: _vm.direction,
        "show-close": true,
        "close-on-press-escape": true,
        "before-close": _vm.clickCancel,
        wrapperClosable: false,
        "with-header": false
      },
      on: {
        "update:visible": function($event) {
          _vm.show = $event
        }
      }
    },
    [
      _c("header", [_c("span", [_c("i"), _vm._v("自动分组")])]),
      _vm._v(" "),
      _c("section", [
        _c("div", { staticClass: "to_group" }, [
          _vm._v("\n  \t\t\t待分组人数：" + _vm._s(_vm.toGroupNum) + "\n  \t\t")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "post" }, [
          _c("p", [_vm._v("岗位：")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "post_list" },
            _vm._l(_vm.postList, function(item) {
              return _vm.postList.length
                ? _c("li", [_vm._v(_vm._s(item.name))])
                : _c("li", [_vm._v("暂无岗位")])
            }),
            0
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "post group_num" },
          [
            _c("p", [_vm._v("每组人数：")]),
            _vm._v(" "),
            _c("el-input", {
              attrs: { autocomplete: "off" },
              model: {
                value: _vm.peopleNum,
                callback: function($$v) {
                  _vm.peopleNum = typeof $$v === "string" ? $$v.trim() : $$v
                },
                expression: "peopleNum"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("p", { staticClass: "notes" }, [
          _vm._v(
            "注：每组人数不能超过岗位数，小组成员岗位自动分配，支持一人多岗位。"
          )
        ])
      ]),
      _vm._v(" "),
      _c("footer", [
        _c(
          "div",
          { staticClass: "btn" },
          [
            _c("el-button", { on: { click: _vm.clickCancel } }, [
              _vm._v("取消")
            ]),
            _vm._v(" "),
            _c(
              "el-button",
              {
                attrs: { type: "primary" },
                on: {
                  click: function($event) {
                    return _vm.submitForm()
                  }
                }
              },
              [_vm._v("保存")]
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1b73f242", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b73f242","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/TeachClass/components/autoGroup.vue
// module id = null
// module chunks = 